// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const invResourceCategoryId = (z.number());
export const invResourceCategory = z.object({
    id: invResourceCategoryId,
    name: z.string(),
});
export const invResourceCategoryInitializer = z.object({
    id: invResourceCategoryId.optional(),
    name: z.string(),
});
export const invResourceCategoryMutator = z.object({
    id: invResourceCategoryId.optional(),
    name: z.string().optional(),
});
//# sourceMappingURL=InvResourceCategory.js.map